import React, { useState } from "react";
import "./Review.css";
import axios from "axios";
import { toast } from "react-toastify";

const Review = ({ prodid, orderid, type }) => {
  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(0);
  const [description, setDescription] = useState("");
  //   const [image, setImage] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [imageFile, setImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);

  //   const handleImageChange = (e) => {
  //     if (e.target.files[0]) {
  //       setImage(URL.createObjectURL(e.target.files[0]));
  //       setShowModal(false);
  //     }
  //   };

  const userData = JSON.parse(localStorage.getItem("userData") || "{}");

  const handleImageChange = (e) => {
    if (e.target.files[0]) {
      setImageFile(e.target.files[0]);
      setImagePreview(URL.createObjectURL(e.target.files[0]));
      setShowModal(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();

    if (type === "cancel") {
      formData.append("order_id", prodid);
      formData.append("reason", description);
    } else {
      formData.append("prod_id", prodid);
      formData.append("order_id", orderid);
      formData.append("cust_id", userData?.id);
      formData.append("commands", description);
      formData.append("rating", rating);
      if (imageFile) {
        formData.append("review_img", imageFile);
      }
    }

    const EP = type === "review" ? "review_add" : "order_cancel";
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BASEURL}/apis/customer/${EP}.php`,
        formData
      );
      const message = res.data?.success;
      if (message === true) {
        if (type === "review") {
          toast.success("Review submitted successfully!");
          setRating(0);
          setHover(0);
          setDescription("");
          setImageFile(null);
          setImagePreview(null);
        } else {
          toast.success("Order Cancelled successfully!");
          setRating(0);
          setHover(0);
          setDescription("");
          setImageFile(null);
          setImagePreview(null);
        }
      } else {
        alert(`Failed to submit ${type}.`);
      }
    } catch (err) {
      console.error("Error submitting review", err);
      alert("An error occurred while submitting your review.");
    }
  };

  return (
    <div className="review-container">
      {/* <div className="left-panel">
        <h3>What makes a good review</h3>
        <p><strong>Have you used this product?</strong><br />Your review should be about your experience with the product.</p>
        <p><strong>Why review a product?</strong><br />Your valuable feedback will help fellow shoppers decide!</p>
        <p><strong>How to review a product?</strong><br />Your review should include facts. An honest opinion is always appreciated.</p>
      </div> */}

      <div className="right-panel">
        <form onSubmit={handleSubmit}>
          {type === "review" && (
            <div className="rating-section">
              <h4>Rate this product</h4>
              <div className="star-row">
                {[...Array(5)].map((_, i) => {
                  const starValue = i + 1;
                  return (
                    <span
                      key={i}
                      className={`star ${
                        starValue <= (hover || rating) ? "active" : ""
                      }`}
                      onClick={() => setRating(starValue)}
                      onMouseEnter={() => setHover(starValue)}
                      onMouseLeave={() => setHover(0)}
                    >
                      ★
                    </span>
                  );
                })}
              </div>
            </div>
          )}

          <div className="input-section">
            <label>{type == "review" ? "Description" : "Cancel Reason"}</label>
            <textarea
              rows="4"
              cols="100"
              placeholder={
                type == "review"
                  ? "Describe your experience..."
                  : "Please enter a reason for cancellation..."
              }
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              required
            ></textarea>
          </div>

          {type === "review" && (
            <div className="image-upload">
              <div className="upload-icons" onClick={() => setShowModal(true)}>
                +
              </div>
              {imagePreview && (
                <img src={imagePreview} alt="Preview" className="preview-img" />
              )}
            </div>
          )}

          <button type="submit" className="submit-btn">
            SUBMIT
          </button>
        </form>
      </div>
      {showModal && (
        <div className="modal-backdrop">
          <div className="modal-content">
            <span className="close-btn" onClick={() => setShowModal(false)}>
              ×
            </span>
            <h4>Select an image</h4>
            <input type="file" accept="image/*" onChange={handleImageChange} />
          </div>
        </div>
      )}
    </div>
  );
};

export default Review;
